import { FC } from 'react';
import * as semrush from '@anm/helpers/semrush';
import { getDestinationUrl, openPopup } from '../helpers';
import { ConnectToFacebookModalProps } from '../types';

import { ButtonsWrapper, CancelButton, ConnectButton, ModalTextWrapper, ModalTitle, ModalWrapper } from './Wrapper';

const ConnectToFacebookModal: FC<ConnectToFacebookModalProps> = ({
  waveApiUrl,
  onModalClose,
  isReconnect,
  destinationTitle = ''
}) => {
  const canAddAdminOnlyParam = destinationTitle.split(' ')[1] === 'group' && !isReconnect;
  const facebookDestinationUrl = getDestinationUrl({
    waveApiUrl,
    title: destinationTitle,
    network: 'FACEBOOK',
    isAdminOnly: canAddAdminOnlyParam,
    isReconnect
  });

  const facebookDestinationType = destinationTitle || 'Facebook page';

  const appName = semrush.isSemrushIframe() ? '' : 'Wave.video';

  return (
    <ModalWrapper {...{ onModalClose }}>
      <ModalTitle title="Connect Facebook" />
      <ModalTextWrapper>
        Connect the account to broadcast directly to your {facebookDestinationType}. Once you grant {appName} access,
        you’ll be ready to go live and schedule your live streams.
      </ModalTextWrapper>
      <ButtonsWrapper>
        <CancelButton variant="white-blue-border-share" size="medium" onClick={onModalClose}>
          Cancel
        </CancelButton>
        <ConnectButton
          variant="light-blue"
          size="medium"
          onClick={() => {
            openPopup({ link: facebookDestinationUrl, network: 'FACEBOOK' });
            onModalClose();
          }}
        >
          Connect
        </ConnectButton>
      </ButtonsWrapper>
    </ModalWrapper>
  );
};

export default ConnectToFacebookModal;
